import { createSelector } from '@reduxjs/toolkit';

const selectAirCompressor = state => state.airCompressors;

export const selectAirCompressorData = createSelector(
  [selectAirCompressor],
  airCompressor => airCompressor.data
);

export const selectAirCompressorLoading = createSelector(
  [selectAirCompressor],
  airCompressor => airCompressor.loading
);

export const selectAirCompressorError = createSelector(
  [selectAirCompressor],
  airCompressor => airCompressor.error
);

export const selectAirCompressorMaintenanceRecordsData = createSelector(
  [selectAirCompressor],
  airCompressor => airCompressor.maintenanceRecordsData
);

export const selectMaintenanceRecordData = createSelector(
  [selectAirCompressor],
  airCompressor => airCompressor.maintenanceRecordData
);

export const selectAirCompressorMaintenanceData = createSelector(
  [selectAirCompressor],
  airCompressor => airCompressor.maintenanceData
);

export const selectCellHistoryData = createSelector(
  [selectAirCompressor],
  airCompressor => airCompressor.cellHistoryData
);

export const selectTileView = createSelector(
  [selectAirCompressor],
  airCompressor => airCompressor.tileView
);
